/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edit_Product_DescriptionInputs */

const en_edit_product_description = /** @type {(inputs: Edit_Product_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update product details.`)
};

const es_edit_product_description = /** @type {(inputs: Edit_Product_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualiza los detalles del producto.`)
};

/**
* | output |
* | --- |
* | "Update product details." |
*
* @param {Edit_Product_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const edit_product_description = /** @type {((inputs?: Edit_Product_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edit_Product_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_edit_product_description(inputs)
	return es_edit_product_description(inputs)
});